module.exports = __webpack_public_path__ + "static/media/PiaLogo.c10ded70.png";